import { apiClient } from "./apiClient";

export interface Borda {
  id: number;
  nome: string;
  lojaId: number;
  createdAt: string;
  updatedAt: string;
}

export interface BordaFilters {
  nome?: string;
  lojaId?: number;
}

export interface BordaFormData {
  nome: string;
  lojaId: number;
}

export const bordaService = {
  getBordas: async (filters?: BordaFilters): Promise<Borda[]> => {
    const params = new URLSearchParams();
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          params.append(key, String(value));
        }
      });
    }
    const query = params.toString();
    return apiClient.get(`/bordas${query ? `?${query}` : ""}`);
  },

  createBorda: async (data: BordaFormData): Promise<Borda> => {
    return apiClient.post("/bordas", data);
  },

  updateBorda: async (id: number, data: BordaFormData): Promise<Borda> => {
    return apiClient.put(`/bordas/${id}`, data);
  },

  deleteBorda: async (id: number): Promise<void> => {
    return apiClient.delete(`/bordas/${id}`);
  },
};
